import { Link } from 'react-router-dom';
import { formatBRL, formatKwh } from '@/lib/format';
import type { SessionOut } from '@/api/charging';

interface Props {
  session: SessionOut;
}

/**
 * Banner de sessão ativa — refinada: navy fill com aurora-arc à direita
 * e CTA "Ver" pílula cream. Indica que existe recarga em andamento e
 * leva pra tela de ActiveCharge.
 */
export function ActiveSessionAlert({ session }: Props) {
  return (
    <Link
      to={`/charging/${session.id}`}
      className="relative flex items-center justify-between overflow-hidden rounded-3xl bg-bow-royal p-5 text-bow-cream shadow-deep"
    >
      <span
        aria-hidden
        className="pointer-events-none absolute -right-16 -top-10 h-44 w-44 rounded-full opacity-50"
        style={{
          background:
            'conic-gradient(from 220deg at 50% 100%, transparent, rgba(0,192,114,0.5) 30%, rgba(0,187,222,0.5) 50%, rgba(131,69,186,0.5) 70%, transparent 90%)',
          filter: 'blur(20px)'
        }}
      />
      <div className="relative flex flex-col gap-1.5">
        <span className="inline-flex items-center gap-1.5 text-[11px] font-semibold uppercase tracking-[0.06em] text-bow-cream/65">
          <span className="inline-block h-1.5 w-1.5 animate-pulse rounded-full bg-bow-green" />
          Recarga em andamento
        </span>
        <span className="text-lg font-semibold tracking-tighter">
          {formatKwh(session.energy_kwh)} · {formatBRL(session.cost_brl)}
        </span>
      </div>
      <span className="relative inline-flex h-10 items-center justify-center rounded-full bg-bow-cream px-4 text-sm font-semibold text-bow-royal">
        Ver
      </span>
    </Link>
  );
}
